import {eatalianoAxios} from "@/data/api/http/axios";
import { Message } from "@/data/entities/message";
import {User} from "@/data/entities/user";

export const signIn = (username: string, password: string): Promise<User> => (
    eatalianoAxios
        .post("/auth/sign-in", {
            username: username,
            password: password
        })
        .then(response => response.data.user)
);

export const signOut = (): Promise<Message> => (
    eatalianoAxios
        .post("/auth/sign-out")
        .then(response => response.data)
);

export const requestPasswordReset = (username: string): Promise<Message> => (
    eatalianoAxios
        .post("/auth/reset", {username, admin: true,})
        .then(response => response.data)
);

export const confirmPasswordReset = (username: string, token: string, password: string): Promise<Message> => (
    eatalianoAxios
        .post("/auth/reset/confirm", {
            username: username,
            token: token,
            password: password
        })
        .then(response => response.data)
);